/** Keep in sync with `RESERVED_SUPPORTER_ROUTE_SEGMENTS` in `src/supporterBoards.ts`. */
export const RESERVED_SUPPORTER_ROUTE_SEGMENTS = new Set([
	"api",
	"c",
	"r",
	"admin",
	"account",
	"assets",
	"billing",
	"membership",
	"rooms",
	"about",
	"privacy",
	"security",
	"math",
	"gears",
	"help",
	"trust",
]);

export function isReservedSupporterRouteSlug(slug: string): boolean {
	return RESERVED_SUPPORTER_ROUTE_SEGMENTS.has(slug);
}
